export default __webpack_public_path__ + "static/media/SystemMetrics.28a90c4b.md";